import { defineComponent as l, toRef as d, h as t } from "vue";
import u from "./ghl-ui.es1567.js";
import f from "./ghl-ui.es908.js";
import c from "./ghl-ui.es905.js";
const r = "1.6s", p = {
  strokeWidth: {
    type: Number,
    default: 28
  },
  stroke: {
    type: String,
    default: void 0
  }
}, h = l({
  name: "BaseLoading",
  props: Object.assign({
    clsPrefix: {
      type: String,
      required: !0
    },
    show: {
      type: Boolean,
      default: !0
    },
    scale: {
      type: Number,
      default: 1
    },
    radius: {
      type: Number,
      default: 100
    }
  }, p),
  setup(a) {
    f("-base-loading", u, d(a, "clsPrefix"));
  },
  render() {
    const {
      clsPrefix: a,
      radius: s,
      strokeWidth: o,
      stroke: i,
      scale: n
    } = this, e = s / n;
    return t("div", {
      class: `${a}-base-loading`,
      role: "img",
      "aria-label": "loading"
    }, t(c, null, {
      default: () => this.show ? t("div", {
        key: "icon",
        class: `${a}-base-loading__transition-wrapper`
      }, t("div", {
        class: `${a}-base-loading__container`
      }, t("svg", {
        class: `${a}-base-loading__icon`,
        viewBox: `0 0 ${2 * e} ${2 * e}`,
        xmlns: "http://www.w3.org/2000/svg",
        style: {
          color: i
        }
      }, t("g", null, t("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: `0 ${e} ${e};270 ${e} ${e}`,
        begin: "0s",
        dur: r,
        fill: "freeze",
        repeatCount: "indefinite"
      }), t("circle", {
        class: `${a}-base-loading__icon`,
        fill: "none",
        stroke: "currentColor",
        "stroke-width": o,
        "stroke-linecap": "round",
        cx: e,
        cy: e,
        r: s - o / 2,
        "stroke-dasharray": 5.67 * s,
        "stroke-dashoffset": 18.48 * s
      }, t("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        values: `0 ${e} ${e};135 ${e} ${e};450 ${e} ${e}`,
        begin: "0s",
        dur: r,
        fill: "freeze",
        repeatCount: "indefinite"
      }), t("animate", {
        attributeName: "stroke-dashoffset",
        values: `${5.67 * s};${1.42 * s};${5.67 * s}`,
        begin: "0s",
        dur: r,
        fill: "freeze",
        repeatCount: "indefinite"
      })))))) : t("div", {
        key: "placeholder",
        class: `${a}-base-loading__placeholder`
      }, this.$slots)
    }));
  }
});
export {
  h as default
};
